import React, { useState } from 'react'
import { Card, CardActionArea, CardHeader, CardContent, Menu, MenuItem, Typography } from '@material-ui/core'
import { useTheme } from '@material-ui/core/styles'
import { ObjetoAvatar } from 'components'
import useStyles from './styles'

export const BaseCard = (props) => {
  const { 
    avatar, 
    title, 
    onClick, 
    onNovaAba, 
    action, 
    children, 
    aninhado = false, 
    tabular = true,
    styleHeader = {}
  } = props
  
  const classes = useStyles({ aninhado, tabular })
  const theme = useTheme()

  const [anchorEl, setAnchorEl] = useState(null)
  const [mouseX, setMouseX] = useState(0)
  const [mouseY, setMouseY] = useState(0)

  const handleContextMenu = (event) => {
    if (onNovaAba) {
      event.preventDefault()
      setAnchorEl(event.currentTarget)
      setMouseX(event.clientX)
      setMouseY(event.clientY)
    }
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const handleClickNovaAba = () => {
    if (onNovaAba) {
      onNovaAba()
    }
    handleClose()
  }

  const renderAvatar = () => {
    if (typeof avatar === 'string') {
      return <ObjetoAvatar tipo={avatar} />
    }
    return avatar
  }

  const renderTitle = () => {
    if (typeof title === 'string') {
      return <Typography className={classes.headerTitle}>{title}</Typography>
    }
    return title
  }

  return (
    <div>
      <Card className={classes.card} onContextMenu={handleContextMenu}>
        <CardActionArea 
          onClick={onClick} 
          className={classes.cardActionArea} 
          disableRipple
        >
          <CardHeader
            avatar={renderAvatar()}
            title={renderTitle()}
            action={action}
            style={{ 
              borderBottom: `1px solid ${theme.palette.divider}`,
              ...styleHeader 
            }}
          />

          <CardContent className={classes.cardContent}>
            {children}
          </CardContent>
        </CardActionArea>
      </Card>

      {onNovaAba && (
        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={handleClose}
          anchorReference="anchorPosition"
          anchorPosition={{ top: mouseY, left: mouseX }}
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'left',
          }}
        >
          <MenuItem onClick={handleClickNovaAba}>Abrir em nova aba</MenuItem>
        </Menu>
      )}
    </div>
  )
}
